module.exports = __webpack_public_path__ + "img/20220624135929.a8326c01.png";